// Entrypoint for the landing layout (/, /session/*, /registration/*,
// /projects, /projects/new). Turbo + a tiny Stimulus app with ONLY the
// controllers that actually attach to these pages. We intentionally do
// NOT use `import.meta.glob(controllers/*)` like application.js does —
// that would pull Konva, suncalc, rule packs, etc. through the editor
// controllers' static imports and inflate the landing bundle by hundreds
// of KB.
import * as Turbo from "@hotwired/turbo"
import { Application } from "@hotwired/stimulus"

import DraftMigrationController from "../controllers/draft_migration_controller"
import ShareController from "../controllers/share_controller"

Turbo.start()

const application = Application.start()
application.debug = false

application.register("draft-migration", DraftMigrationController)
application.register("share", ShareController)
